module.exports = __webpack_public_path__ + "img/c-min.b7e3e44d.jpg";